<template>
  <section>
    <div class="card" style="border-radius: 5px;">
      <header class="card-header-parts" v-if="isConfirmByParts">
        <b>【パーツ別確認】{{typeParts(scenarioEdit.status)}}（種類別確定済パーツ数 {{countConfirmParts(scenarioEdit.status)}}/{{countParts(scenarioEdit.status)}}）</b>
        <span style="margin: 0 0 0 auto; cursor: pointer;" @click="closeEditPage()">×</span>
      </header>
      <header class="card-header-parts" v-if="isConfirmByStories">
        <b>【ストーリー別確認】（{{countConfirmStories()}}/{{allStory.length}}）</b>
        <span style="margin: 0 0 0 auto; cursor: pointer;" @click="closeEditPage()">×</span>
      </header>
      <header class="card-header">
        <div class="card-header-title edit-title-wrapper">
          <span class="edit-title">会話シナリオ編集 ({{scenarioEdit.pk}})</span>
          <div class="quote-container">
            <!-- BACK BTN AREA -->
            <div class="quote-btn-container" v-if="
              scenarioEdit.status===0  ||
              scenarioEdit.status===6  ||
              scenarioEdit.status===13 ||
              scenarioEdit.status===15 ||
              scenarioEdit.status===17 ||
              scenarioEdit.status===20
            ">
              <span>戻る</span>
              <button
                class="quote-btn button is-small"
                :class="{'is-primary': scenarioEdit.is_back}"
                @click="scenarioEdit.is_back = !scenarioEdit.is_back"
                :disabled="scenarioEdit.is_confirm">
                <template v-if="scenarioEdit.is_back">ON</template>
                <template v-else>OFF</template>
              </button>
            </div>
            <!-- CV AREA -->
            <div class="quote-btn-container" v-if="scenarioEdit.status!=22 && scenarioEdit.status!=100">
              <span>GOAL</span>
              <button
                class="quote-btn button is-small"
                :class="{'is-primary': scenarioEdit.is_cv}"
                @click="scenarioEdit.is_cv = !scenarioEdit.is_cv"
                :disabled="scenarioEdit.is_confirm">
                <template v-if="scenarioEdit.is_cv">ON</template>
                <template v-else>OFF</template>
              </button>
            </div>
            <!-- 引用可能にしたいものはここに追加 -->
            <div class="quote-btn-container"
              v-if="
              scenarioEdit.status===0  ||
              scenarioEdit.status===1  ||
              scenarioEdit.status===4  ||
              scenarioEdit.status===6  ||
              scenarioEdit.status===8  ||
              scenarioEdit.status===13 ||
              scenarioEdit.status===15 ||
              scenarioEdit.status===17">
              <span>回答引用</span>
              <button
                class="quote-btn button is-small"
                :class="{'is-primary': quoteFlg}"
                @click="quoteFlg = !quoteFlg"
                :disabled="scenarioEdit.is_confirm">
                <template v-if="quoteFlg">ON</template>
                <template v-else>OFF</template>
              </button>
            </div>
            <div v-else></div>
            <div v-if="scenarioEdit.status!==22 && scenarioEdit.status!==100" class="open-quote-btn-container">
              <p class="open-quote-btn" @click="toggleQuoteList">引用リスト</p>
            </div>
          </div>
        </div>
      </header>
      <div class="story-box disp-scroll" v-if="isConfirmByStories">
        <div v-if="!scenarioEdit.start_flg">
          <Tooltip message="前のパーツ">
            <div class="story-card" @click="storyPrevParts()">
              【{{prevStoryStatus()}}】<br>
              {{prevStoryMessage()}}
            </div>
          </Tooltip>
        </div>
      </div>
      <div v-bind:class="[{'card-content-parts': isConfirmByParts ,'card-content-stories': isConfirmByStories}, 'card-content scroll-box disp-scroll']" v-if="isSelect">
        <p style="text-align: center;" v-if="isConfirmByStories && modalScenario.length == 0">ストーリーがありません</p>
        <!-- 選択肢ありパーツ -->
        <ModalEditSelectParts v-if="scenarioEdit.status===0"
          :scenarioEdit="scenarioEdit"
          @add-select="addSelect"
          @del-select="delSelect"
          @is-disable="isDisable"
          @change-mainmessage="changeMainmessage"
          @change-btn-message="changeBtnMessage"
          @change-btn-url="changeBtnUrl"
          @change-btn-point="changeBtnPoint"
          @click-url="clickUrl" />
        <!-- メッセージのみ -->
        <ModalEditMessageParts v-if="scenarioEdit.status===2"
          :scenarioEdit="$_.cloneDeep(scenarioEdit)"
          @change-mainmessage="changeMainmessage" />
        <!-- 自由入力 -->
        <ModalEditInputParts
          v-if="scenarioEdit.status===6"
          :scenarioEdit="$_.cloneDeep(scenarioEdit)"
          :seekerSaveList="$_.cloneDeep(seekerSaveList)"
          :inputParameter="$_.cloneDeep(inputParameter)"
          @change-mainmessage="changeMainmessage"
          @change-param="changeInputParam"/>
        <!-- メール送付 -->
        <ScenarioEditEmail
          v-if="scenarioEdit.status===10"
          :emailParameter="emailParameter"
          :scenarioEdit="scenarioEdit"
          :options="options"
          @update-title="updateTitle"
          @update-from="updateFrom"
          @update-to="updateTo"
          @update-cc="updateCc"
          @update-bcc="updateBcc"
          @update-mainmessage="updateMainmessage"
          @update-after="updateAfter"
          @update-same-day="updateSameDay"
        />
        <!-- SMS送付 -->
        <ModalEditSMSParts
          v-if="scenarioEdit.status===16"
          :scenarioEdit="scenarioEdit"/>
        <!-- 応募フォームシナリオ -->
        <ScenarioEditApply
          v-if="scenarioEdit.status===1"
          :scenarioEdit="scenarioEdit"
          :applyParameter="applyParameter"
          @update-mainmessage="updateMainmessage"
        />
        <!-- 履歴書フォーム -->
        <ModalResumeParts
          v-if="scenarioEdit.status===8"
          :scenarioEdit="scenarioEdit"
          :isGoogleDriveAuth="isGoogleDriveAuth"
          :userId="user.userHash"
        />
        <!-- Startに戻る -->
        <ScenarioEditStart v-if="scenarioEdit.status===9"/>
        <!-- ロボ切替 -->
        <ModalEditChangeParts
          v-if="scenarioEdit.status===3"
          :scenarioEdit="scenarioEdit"
          :chatbots="chatbots"/>
        <!-- 日程自動調整 -->
        <ModalContentSchedule
          v-if="scenarioEdit.status===4"
          ref="scheduleEdit"
          :user="user"
          :users="users"
          :calendarSettings="calendarSettings"
          :scenarioEdit="scenarioEdit"
          :scheduleParam="scenarioEdit.parameter"
          :usersStatusAPI="usersStatusAPI"
          @add-select="addSelect"
          @del-select="delSelect"
          @setScheduleParameter="setScheduleParameter"
          @setScheduleCheck="setScheduleCheck"
        />
        <!-- 画像 -->
        <div v-if="scenarioEdit.status===5">
          <p>画像を選択</p>
          <a class="button is-primary"
            @click="openSelectModal('image')"
            style="margin-bottom:16px;"
            :disabled="scenarioEdit.is_confirm">
            <span class="mdi mdi-image" style="margin-right: 10px;"></span>メディア倉庫から画像を選択する
          </a>
          <b-input readonly :disabled="scenarioEdit.is_confirm" style="width: 95%;" placeholder="アップロードファイル" v-model="imagName" max-length="100"></b-input>
        </div>
        <!-- ファイルアップロード -->
        <ScenarioEditUpload
          v-if="scenarioEdit.status===7"
          :uploadParameter="uploadParameter"
          :isGoogleDriveAuth="isGoogleDriveAuth"
          :userId="user.userHash"
          :scenarioEdit="scenarioEdit"
          @update-is-resume="updateIsResume"
          @update-to-google-drive="updateToGoogleDrive"
          @update-drive-info="updateDriveInfo"
        />
        <!-- 条件分岐 -->
        <ScenarioEditIf
          v-if="scenarioEdit.status===12"
          :selectItem="selectItem"
          :ifItems="ifItems"
          :scenarioEdit="scenarioEdit"
          :delPattern="delPattern"
          :delSelect="delSelect"
          :addPattern="addPattern"
          :addSelect="addSelect"
          :point_paterns="point_paterns"
          :word_paterns="word_paterns"
          :displayQuoteMsg="displayQuoteMsg"
          :userinfo_quotes="selectChatbot.robo_arguments"
          :userinfo_patterns="userinfo_patterns"
          :minirobo_patterns="minirobo_patterns"
          :isRoboPartsSetView="isRoboPartsSetView"
          @update-select-item="updateSelectItem"
          @update-point-list-point="updatePointListPoint"
          @update-point-list-terms="updatePointListTerms"
          @update-point-list-reset="updatePointListReset"
          @update-word-parts-number="updateWordPartsNumber"
          @update-word-list-word="updateWordListWord"
          @update-word-list-terms="updateWordListTerms"
          @update-user-info-quotes="updateUserInfoQuotes"
          @update-user-info-word="updateUserInfoWord"
          @update-user-info-terms="updateUserInfoTerms"
          @update-minirobo-variable="updateMiniroboVariable"
          @update-minirobo-word="updateMiniroboWord"
          @update-minirobo-terms="updateMiniroboTerms"
        />
        <!-- チェックボックス -->
        <div class="check" v-if="scenarioEdit.status===13">
          <div class="columns is-multiline is-mobile">
            <div class="column disp-scroll" style="margin-right: 5px; background-color:white;">
              <p>チェックボックス項目を編集、追加できます。</p>
              <p>メッセージ</p>
              <input class="input" v-model="scenarioEdit.mainmessage" :disabled="scenarioEdit.is_confirm"/>
              <div class="dot-line"></div>
              <template v-if="filteredCustomColumns.length > 0 && !isColumnLoading">
                <p>設定項目</p>
                <b-select class="select colomn-name"
                  placeholder="詳細項目"
                  v-model="scenarioEdit.company_column"
                  :disabled="scenarioEdit.is_confirm"
                  expanded>
                    <option value=""></option>
                    <option
                      v-for="(comCol, idx) in filteredCustomColumns"
                      :value="comCol"
                      :key="idx + '-comCol'">
                      {{getCustomName(comCol)}}
                    </option>
                </b-select>
                <div class="dot-line"></div>
              </template>
              <div class="checkbox-item-container" v-for="(parameter, scnIDX) in scenarioEdit.parameter" :key="scnIDX">
                <b-field class="checkbox-item-container -wrapper">
                  <p class="checkbox-index">{{scnIDX + 1}},</p>
                  <b-input placeholder="チェック項目を入力" v-model="parameter['item_message']" expanded :disabled="scenarioEdit.is_confirm"></b-input>
                  <button class="button" style="background: #f8f8f8;" @click="delSelectCheckBox(scnIDX)" v-if="scenarioEdit.parameter.length > 1" :disabled="scenarioEdit.is_confirm"><span class="mdi mdi-close"></span></button>
                </b-field>
              </div>
              <p v-if="this.scenarioEdit.parameter.length < 10" style="font-size: 13px; padding:10px;">
                <button class="button is-fullwidth" @click="addSelectCheckBox()" :disabled="scenarioEdit.is_confirm"><i class="mdi mdi-plus-box"></i>チェックボックス追加</button>
              </p>
            </div>
          </div>
        </div>
        <!-- 動画 -->
        <div v-if="scenarioEdit.status===14">
          <p>動画のURLを入力</p>
          <b-field grouped>
            <b-radio v-model="movieParameter.use" native-value="youtube" :disabled="scenarioEdit.is_confirm"></b-radio>
            <b-input :disabled="movieParameter.use!='youtube' || scenarioEdit.is_confirm" style="width: 95%;" placeholder="URLを入力" v-model="movieParameter.url" max-length="100"></b-input>
          </b-field>
          <p>動画をアップロード</p>
          <b-field grouped>
            <b-radio v-model="movieParameter.use" native-value="movie_file" :disabled="scenarioEdit.is_confirm"></b-radio>
            <b-input readonly :disabled="movieParameter.use=='youtube' || scenarioEdit.is_confirm" style="width: 95%;" placeholder="アップロードファイル" v-model="movieParameter.filename" max-length="100"></b-input>
          </b-field>
          <a class="button is-primary"
            @click="openSelectModal('video')"
            v-if="!scenarioEdit.is_confirm">
            <span class="mdi mdi-image" style="margin-right: 10px;"></span>メディア倉庫から動画を選択する
          </a>
          <a class="button is-primary"
            v-else
            disabled>
            <span class="mdi mdi-image" style="margin-right: 10px;"></span>メディア倉庫から動画を選択する
          </a>
        </div>
        <ModalEditPulldownParts
          v-if="scenarioEdit.status === 15"
          :scenarioEdit="scenarioEdit"
          :filteredCustomColumns="filteredCustomColumns"
          :isColumnLoading="isColumnLoading"
          :getCustomName="getCustomName"
          :getCustomColumnId="getCustomColumnId"
        />
        <!-- カルーセル -->
        <div class="message disp-scroll" v-if="scenarioEdit.status===17">
          <div class="add-carousel-tag">
            <div style="margin: 0 0 0 auto;">
              <button
                class="button is-small"
                @click="addCarousel()"
                v-if="Object.keys(selectCarousel).length < 10"
                :disabled="scenarioEdit.is_confirm">
                選択肢の追加
              </button>
            </div>
          </div>
          <b-tabs style="background: white;" v-model="carouselTab" class="carouselOrderable">
            <b-tab-item :label="'選択肢' + i.id" class="tab-box disp-scroll" v-for="(i, index, s) in selectCarousel" :key = index style="margin-top:8px">
              <template slot="header">
                <span class="carouselOrder" :class="'carouselOrder-' + i.id">選択肢{{i.id}}</span>
              </template>
              <div class="tab-box-form" v-if="Object.keys(selectCarousel).length > 2">
                <div style="margin:0 0 0 auto">
                  <button
                    class="button is-small is-danger"
                    @click="deleteCarouselTag(index, i, s)"
                    :disabled="scenarioEdit.is_confirm">
                    選択肢{{i.id}}を削除する
                  </button>
                </div>
              </div>
              <div class="tab-box-form">
                <div class="tab-box-left">
                  <div class="upload-button">
                    <p style="text-align: left;">
                      <b>画像</b>
                    </p>
                  </div>
                </div>
                <div class="tab-box-right">
                  <div @click="openSelectModal('image'); editCarousel(i);" v-if="!scenarioEdit.is_confirm">
                    <a class="button is-small" style="margin-top: 8px;">
                      <span class="mdi mdi-image" style="margin-right: 8px;"></span>画像
                    </a>
                  </div>
                  <div v-else>
                    <a class="button is-small" style="margin-top: 8px;" disabled>
                      <span class="mdi mdi-image" style="margin-right: 8px;"></span>画像
                    </a>
                  </div>
                  <div style="margin:14px 0 0 10px; width:80%;　white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ">{{i.image_ref.name}}</div>
                  <div style="cursor: pointer; margin: 4px 0 0 0;" v-if="displayDeleteBtn(i) && !scenarioEdit.is_confirm" @click="deleteCarouselImage(i)"><span class="mdi mdi-delete mdi-24px" /></div>
                  <div style="cursor: not-allowed; margin: 4px 0 0 0;" v-if="displayDeleteBtn(i) && scenarioEdit.is_confirm"><span class="mdi mdi-delete mdi-24px" style="color: #ccc;"/></div>
                </div>
              </div>
              <div class="dot-line"></div>
              <div class="tab-box-form">
                <div class="tab-box-left">
                  <p style="text-align: left;">
                    <b>タイトル</b>
                  </p>
                </div>
                <div class="tab-box-right">
                  <b-input
                    style="width: 100%;"
                    placeholder="40文字以下で入力してください"
                    v-model="i.title"
                    maxlength="40"
                    :disabled="scenarioEdit.is_confirm">
                  </b-input>
                </div>
              </div>
              <div class="dot-line"></div>
              <div class="tab-box-form">
                <div class="tab-box-left">
                  <p style="text-align: left;">
                    <b>詳細</b>
                  </p>
                </div>
                <div class="tab-box-right">
                  <b-input
                    style="width: 100%;"
                    placeholder="90文字以下で入力してください"
                    v-model="i.contents"
                    maxlength="90"
                    :disabled="scenarioEdit.is_confirm">
                  </b-input>
                </div>
              </div>
              <div class="dot-line"></div>
              <div class="tab-box-form">
                <div class="tab-box-left">
                  <p style="text-align: left;">
                    <b>ボタン</b>
                  </p>
                </div>
                <div class="tab-box-right">
                  <b-input
                    style="width: 100%;"
                    placeholder="20文字以下で入力してください"
                    v-model="i.button"
                    maxlength="20"
                    :disabled="scenarioEdit.is_confirm">
                  </b-input>
                </div>
              </div>
            </b-tab-item>
          </b-tabs>
        </div>
        <!-- ファイルダウンロード -->
        <ScenarioEditDownload
          v-if="scenarioEdit.status === 18"
          :scenarioEdit="scenarioEdit"
          :downloadParameter="downloadParameter"
          :isRoboPartsSetView="isRoboPartsSetView"
          :loadFile="loadFile"
          @update-main-message="updateMainmessage"
          @update-file-path="updateFilepath"
        />
        <!-- 回答出力 -->
        <ModalContentOutputParts
          v-if="scenarioEdit.status===19"
          :scenarioEdit="scenarioEdit"
          :isGoogleDriveAuth="isGoogleDriveAuth"
          :userId="user.userHash"
        />
        <!-- 検索パーツ -->
        <ModalEditSearchParts  v-if="scenarioEdit.status===20"
          :scenarioEdit="scenarioEdit"
          :user="user"
          @outputSearch="outputSearch"
          @add-search-record="addSearchRecord"
          @del-search-record="delSearchRecord"
          @open-select-modal="openSelectModal"
          @edit-search="editSearch"
          @delete-search-img="deleteSearchImg" />
        <!-- PDFダウンロードパーツ -->
        <ModalContentPdfDownloadParts v-if="scenarioEdit.status===21"
          :scenarioEdit="scenarioEdit"/>
        <!-- 付箋パーツ -->
        <ModalFusenParts
          v-if="scenarioEdit.status===22"
          v-model="scenarioEdit.mainmessage"
          :mainmessage="scenarioEdit.mainmessage"
          :isConfirm="scenarioEdit.is_confirm"
        />
        <!-- パーツセット -->
        <ScenarioEditRoboPartsSet
          v-if="scenarioEdit.status===100"
          :scenarioEdit="scenarioEdit"
          :chatbot="selectChatbot"
          :roboPartsSet="roboPartsSet"
        />
        <hr>
        <b-field style="width: 100%" v-if="!isConfirmByParts && !isConfirmByStories">
          <div style="width: 48%; align: left" v-if="!scenarioEdit.is_confirm">
            <button class="button is-primary is-fullwidth" @click="closeEditPage();">
              キャンセル
            </button>
          </div>
          <div style="width: 48%; align: left" v-else>
            <button class="button is-primary is-fullwidth" @click="closeEditPage();">
              閉じる
            </button>
          </div>
          <div style="width: 5%;">
          </div>
          <div style="width: 48%; align: right">
            <button class="button is-primary is-fullwidth"
              @click="clickSaveScenario(true); closeEditPage();"
              :disabled="isDisable()||scenarioEdit.is_confirm">
              会話シナリオ変更
            </button>
          </div>
        </b-field>
        <b-field style="width: 100%" v-if="isConfirmByParts">
          <div style="width: 48%; align: left">
            <button class="button is-primary is-fullwidth" @click="discardEdit();" :disabled="scenarioEdit.is_confirm || !isEdited">
              編集を破棄する
            </button>
          </div>
          <div style="width: 5%;">
          </div>
          <div style="width: 48%; align: right">
            <button class="button is-primary is-fullwidth"
              @click="clickSaveScenario(true);"
              :disabled="scenarioEdit.is_confirm || !isEdited">
              内容を保存する
            </button>
          </div>
        </b-field>
        <b-field style="width: 100%" v-if="!isRoboPartsSetView && modalScenario.length != 0 && isCheckAuthority">
          <button class="button is-primary is-fullwidth" @click="clickSaveScenario(false);" v-if="!scenarioEdit.is_confirm">
            パーツ確定
          </button>
          <button class="button is-primary is-fullwidth" :disabled="selectChatbot.is_confirm" @click="partsConfirm();" v-else>
            パーツ確定解除
          </button>
        </b-field>
      </div>
      <div class="story-box disp-scroll" v-if="isConfirmByStories">
        <div v-for="(select, selectIdx) in modalScenario.select" :key="selectIdx">
          <Tooltip :message="nextMessage(select.message)" v-if="isNextMessage(select.next_node)">
            <div v-if="select.next_node != ''" :class="{'story-card-grey': countStoryConfirm(select.next_node)}" class="story-card" @click="storyChangeParts(select.next_node)">
              【{{changeScenarioStatus(select.next_node)}}】<br>
              {{changeScenarioMessage(select.next_node)}}
              <div style="text-align: right;">{{confirmStories(select.next_node)}}/{{allStories(select.next_node)}}</div>
            </div>
          </Tooltip>
          <div v-else>
            <button class="button is-primary story-card"
              :disabled="getStoryFlg()"
              @click="confirmStory()">
              ストーリーを確認する
            </button>
          </div>
        </div>
      </div>
      <div class="footer-box-stories" v-if="isConfirmByStories && !isRoboPartsSetView">
      </div>  
      <div class="footer-box" v-if="isConfirmByParts && !isRoboPartsSetView">
        <div class="footer-box-parts">
          <div class="footer-tool-tip">
            <Tooltip message="前の種類のパーツ">
              <a v-if="isTypePrevParts()" @click="typePrevParts()"><span class="mdi mdi-rewind"></span></a>
              <a v-else style="cursor: not-allowed; color: #E9BDB5;"><span class="mdi mdi-rewind"></span></a>
            </Tooltip>
          </div>
          <div class="footer-tool-tip">
            <Tooltip message="前のパーツ">
              <a v-if="isPrevParts()" @click="prevParts()"><span class="mdi mdi-play mdi-rotate-180"></span></a>
              <a v-else style="cursor: not-allowed; color: #E9BDB5;"><span class="mdi mdi-play mdi-rotate-180"></span></a>
            </Tooltip>
            </div>
          <div class="footer-tool-tip">
            <Tooltip message="この種類のパーツをすべてロックする" v-if="isCheckAuthority">
              <a v-if="isPartsLock(scenarioEdit.status) && isCheckAuthority" @click="lockTypeParts(scenarioEdit.status)"><span class="mdi mdi-lock"></span></a>
              <a v-if="!isPartsLock(scenarioEdit.status) && isCheckAuthority" style="cursor: not-allowed; color: #E9BDB5;"><span class="mdi mdi-lock"></span></a>
            </Tooltip>
            </div>
          <div class="footer-tool-tip">
            <Tooltip message="次のパーツ">
              <a v-if="isNextParts()" @click="nextParts()"><span class="mdi mdi-play"></span></a>
              <a v-else style="cursor: not-allowed; color: #E9BDB5;"><span class="mdi mdi-play"></span></a>
            </Tooltip>
            </div>
          <div class="footer-tool-tip">
            <Tooltip message="次の種類のパーツ">
              <a v-if="isTypeNextParts()" @click="typeNextParts()"><span class="mdi mdi-fast-forward"></span></a>
              <a v-else style="cursor: not-allowed; color: #E9BDB5;"><span class="mdi mdi-fast-forward"></span></a>
            </Tooltip>
            </div>
        </div>
      </div>
      <div class="quote-list disp-scroll" v-if="quoteListFlg" :style="isConfirmByParts ? 'top: 114px;' : 'top: 64px;'">
        <div class="quote-list-wrapper">
          <div class="title-wrapper">
            <p class="list-title">引用リスト</p>
          </div>
          <section class="quote-list-content">
            <div class="table-container" v-if="citableScenarios.length > 0 || selectChatbot.robo_arguments.length > 0">
              <p class="quote-explain">*パーツNo.をコピーして貼り付けると、該当シナリオのチャットの回答内容が反映されます。</p>
              <table border="1" width="500" cellspacing="0" cellpadding="5" bordercolor="#333333">
                <thead>
                  <tr>
                    <th width="30%"><font>引用シナリオ</font></th>
                    <th width="30%"><font>項目の内容</font></th>
                    <th width="40%"><font>パーツNo.</font></th>
                  </tr>
                </thead>
                <tbody v-for="(c, i) in citableScenarios" :key="i">
                  <tr>
                    <td :rowspan="0">{{displayQuoteMsg(c.mainmessage)}}</td>
                    <td v-if="(c.status == 1 || c.status==8) && user.subscribe_is_name == true">お名前</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '名前'">名前</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == 'Email'">Email</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == 'TEL'">TEL</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '住所'">住所</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '名前（ふりがな）'">名前（ふりがな）</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '生年月日'">生年月日</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '資格'">資格</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '学歴・職歴'">学歴・職歴</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '備考'">備考</td>
                    <td v-else-if="c.status == 15">{{c.parameter[0].title}}</td>
                    <td v-else>回答内容</td>
                    <td v-if="(c.status == 1 || c.status==8) && user.subscribe_is_name == true">__{{c.pk}}.name__</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '名前'">__applicant__</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == 'Email'">__email__</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == 'TEL'">__tel__</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '住所'">__address__</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '名前（ふりがな）'">__furigana__</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '生年月日'">__yyyymmdd__</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '資格'">__shikaku__</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '学歴・職歴'">__career__</td>
                    <td v-else-if="c.status == 6 && c.parameter['colomn_name'] == '備考'">__bikou__</td>
                    <td v-else-if="c.status == 15">__{{c.pk}}.pulldown1__</td>
                    <td v-else>__{{c.pk}}__</td>
                  </tr>
                  <tr v-if="(c.status == 1 || c.status==8) && user.subscribe_is_sex == true">
                    <td>性別</td>
                    <td>__{{c.pk}}.gender__</td>
                  </tr>
                  <tr v-if="(c.status == 1 || c.status==8) && user.subscribe_is_name_phonetic == true">
                    <td>フリガナ</td>
                    <td>__{{c.pk}}.furigana__</td>
                  </tr>
                  <tr v-if="(c.status == 1 || c.status==8) && user.subscribe_is_email == true">
                    <td>Email</td>
                    <td>__{{c.pk}}.email__</td>
                  </tr>
                  <tr v-if="(c.status == 1 || c.status==8) && user.subscribe_is_tel == true">
                    <td>TEL</td>
                    <td>__{{c.pk}}.tel__</td>
                  </tr>
                  <tr v-if="(c.status == 1 || c.status==8) && user.subscribe_is_birth == true">
                    <td>生年月日</td>
                    <td>__{{c.pk}}.birth__</td>
                  </tr>
                  <tr v-if="(c.status == 1 || c.status==8) && user.subscribe_is_address == true">
                    <td>住所</td>
                    <td>__{{c.pk}}.address__</td>
                  </tr>
                  <tr v-if="c.status == 1 && user.subscribe_is_message == true">
                    <td>備考</td>
                    <td>__{{c.pk}}.message__</td>
                  </tr>
                  <tr v-for="(param, idx) in (c.status==15 ? c.parameter.slice(1) : [])" :key="idx">
                    <td>{{param.title}}</td>
                    <td>__{{c.pk}}.pulldown{{idx+2}}__</td>
                  </tr>
                  <tr v-if="c.status == 6 && c.parameter['colomn_name'] == '生年月日'">
                    <td>年齢</td>
                    <td>__years__</td>
                  </tr>
                  <tr v-if="c.status==15">
                    <td>全体引用</td>
                    <td>__{{c.pk}}__</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr v-for="(arg, index) in selectChatbot.robo_arguments" :key="index">
                    <td :rowspan="0" v-if="index==0 && scenarioEdit.status!==21">応募者情報(ロボ引用)</td>
                    <td v-if="scenarioEdit.status!==21">{{arg.name}}</td>
                    <td v-if="scenarioEdit.status!==21">__robo_quote.{{arg.pk}}__</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <p class="not-find-quote">このシナリオで利用できる回答ワードは見つかりませんでした。</p>
            </div>
          </section>
        </div>
      </div>
    </div>
    <ModalSelectMedia
      @updated="saveImage"
      @changeConfirm="changeConfirm"
      :isConfirm="scenarioEdit.is_confirm">
    </ModalSelectMedia>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Cropperjstalk from '@/views/DashBoard/ChatBot/Cropperjstalk'
import ModalSelectMedia from '@/components/ui/ModalSelectMedia'
import ModalEditSelectParts from '@/components/organisms/chatbot/modals/ModalEditSelectParts'
import ModalEditMessageParts from '@/components/organisms/chatbot/modals/ModalEditMessageParts'
import ModalEditChangeParts from '@/components/organisms/chatbot/modals/ModalEditChangeParts'
import ModalEditInputParts from '@/components/organisms/chatbot/modals/ModalEditInputParts'
import ModalEditPulldownParts from '@/components/organisms/chatbot/modals/ModalEditPulldownParts'
import ModalEditSearchParts from '@/components/organisms/chatbot/modals/ModalEditSearchParts'
import ModalContentOutputParts from '@/components/organisms/chatbot/modals/ModalContentOutputParts'
import ModalContentPdfDownloadParts from '@/components/organisms/chatbot/modals/ModalContentPdfDownloadParts'
import ModalFusenParts from '@/components/organisms/chatbot/modals/ModalFusenParts'
import ModalEditSMSParts from '@/components/organisms/chatbot/modals/ModalEditSMSParts'
import ModalContentSchedule from '@/components/organisms/chatbot/modals/ModalContentSchedule'
import ModalResumeParts from '@/components/organisms/chatbot/modals/ModalResumeParts'
import ScenarioEditRoboPartsSet from '@/components/organisms/chatbot/scenarioEdit/ScenarioEditRoboPartsSet'
import ScenarioEditEmail from '@/components/organisms/chatbot/scenarioEdit/ScenarioEditEmail'
import ScenarioEditApply from '@/components/organisms/chatbot/scenarioEdit/ScenarioEditApply'
import ScenarioEditUpload from '@/components/organisms/chatbot/scenarioEdit/ScenarioEditUpload'
import ScenarioEditIf from '@/components/organisms/chatbot/scenarioEdit/ScenarioEditIf'
import ScenarioEditStart from '@/components/organisms/chatbot/scenarioEdit/ScenarioEditStart'
import ScenarioEditDownload from '@/components/organisms/chatbot/scenarioEdit/ScenarioEditDownload'
import alterReplace from '@/functions/alterStrReplace'
import makeUpdateTemplateData from '@/functions/makeUpdateTemplateData'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import Sortable from 'sortablejs'
import SelectMemberTable from '@/components/molecules/tables/SelectMemberTable'
import {isMailAddress} from '@/functions/common/checksFunc'
import cardList from '@/assets/json/master/scenario.json'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  name: 'ScenarioEditor',
  components: {
    Cropperjstalk,
    ModalSelectMedia,
    alterReplace,
    ModalEditSelectParts,
    ModalEditMessageParts,
    ModalEditChangeParts,
    ModalEditInputParts,
    ModalEditPulldownParts,
    ModalEditSearchParts,
    ModalContentOutputParts,
    ModalContentPdfDownloadParts,
    ModalEditSMSParts,
    ModalContentSchedule,
    ModalResumeParts,
    Tooltip,
    SelectMemberTable,
    ModalFusenParts,
    ScenarioEditEmail,
    ScenarioEditApply,
    ScenarioEditUpload,
    ScenarioEditIf,
    ScenarioEditStart,
    ScenarioEditDownload,
    ScenarioEditRoboPartsSet,
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      selectItem: '',
      ifItems: ['ポイント', 'ワード', '応募者情報', 'ミニロボ変数', 'ランダム', 'セッション切替'],
      point_paterns: ['以上', '未満'],
      word_paterns: ['一致する', '異なる', '含む', '含まない'],
      userinfo_patterns: ['一致する', '異なる', '含む', '含まない'],
      minirobo_patterns: ['一致する', '異なる', '含む', '含まない'],
      photo: '',
      isImageSave: false,
      isCardModalActive: false,
      isSelect: true,
      isMessage: false,
      isSaved: false,
      isError: false,
      scenarioName: 'default',
      scenarioEdit: {
        mainmessage: 'default',
        status: 0,
        select: [{
          message: 'default',
          text_option: 'default',
          url: '',
          content: 'default',
          point: 0,
          urlBtnFlg: false
        }],
        parameter: {},
        company_column: '',
        is_confirm: false
      },
      selectedUser: null,
      timeList: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23
      ],
      seekerSaveList: [
        {name: '設定なし', date_format: true, mail_format: true, half_format: true},
        {name: '名前', date_format: false, mail_format: false, half_format: false},
        {name: 'Email', date_format: false, mail_format: true, half_format: false},
        {name: 'TEL', date_format: false, mail_format: false, half_format: false},
        {name: '名前（ふりがな）', date_format: false, mail_format: false, half_format: false},
        {name: '生年月日', date_format: false, mail_format: false, half_format: false},
        {name: '住所', date_format: false, mail_format: false, half_format: false},
        {name: '資格', date_format: false, mail_format: false, half_format: false},
        {name: '学歴・職歴', date_format: false, mail_format: false, half_format: false},
        {name: '備考', date_format: true, mail_format: true, half_format: true},
        {name: '面接予定日', date_format: true, mail_format: false, half_format: false},
        {name: 'カスタム', date_format: true, mail_format: true, half_format: true}
      ],
      weekdayModel: [],
      applyParameter: {
        disable_email: false,
        default_birth: new Date()
      },
      uploadParameter: {
        is_resume: false,
        to_google_drive: false,
        uuid: null,
        username: null,
      },
      inputParameter: {
        colomn_name: '',
        custom_tag: '',
        custom: null,
        input_type: '',
        default_birth: new Date(),
        date_type: '',
        apply_flg: false,
        any_flg: false,
        default_flg: false,
        keep_time_hour: 0,
        keep_time_minute: 0
      },
      emailParameter: {
        title: '',
        to: '',
        cc: '',
        bcc: '',
        after: 0,
        is_same_day: false,
      },
      movieParameter: {
        url: '',
        use: 'youtube',
        filename: ''
      },
      downloadParameter: {
        filename: [],
        filepaths: [],   // DBには保存しない
        tempfilepath: '' // DBには保存しない
      },
      resumeParameter: {
        image_required: true,
        default_birth: new Date()
      },
      calendarParameter: null,
      croppa: null,
      options: {
        theme: 'snow',
        placeholder: '内容を入力...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }]]
        }
      },
      quoteFlg: false,
      quoteListFlg: false,
      citableScenarios: [],
      selectCarousel: {},
      carouselEdit: false,
      carouselNumber: "",
      carouselTab: 0,
      searchEdit: false,
      isColumnLoading: false,
      companyColumns: [],
      searchNumber: "",
      csvSearchFile: null,
      scheduleCheck: false,
      cardList: cardList,
      prevStories: [],
      selectStoryList: [],
      isCheckAuthority: false,
      scenarioBeforeEdit: undefined,
      imagName: '',
      isImageSet: false,
    }
  },
  computed: {
    ...mapState('auth', ['user', 'users', 'isGoogleDriveAuth', 'calendarSettings', 'usersStatusAPI', 'companyColumnSetting']),
    ...mapState('chatbot', ['selectChatbot', 'selectScenario', 'scenarioTable', 'modalScenario', 'isModalEditScenario', 'chatbots', 'isRoboPartsSetView', 'roboPartsSet', 'selectTemplateId', 'isModalChatBotDetail', 'isConfirmByParts', 'isConfirmByStories', 'allStory', 'storyConfirm']),
    ...mapState('calendar', ['recommendDate']),
    ...mapState('mediapool', ['selectModalTarget', 'videos', 'images']),
    filteredCustomColumns () {
      let sortedColumns = this.companyColumns.sort((a, b) => {
        if (a.order_type < b.order_type) return -1
        if (a.order_type > b.order_type) return 1
        return 0
      })
      return this.$_.map(
        this.$_.filter(
          sortedColumns,
          ((obj) => {
            return obj.template_type === 0
          })
        ),
        this.$_.property('pk')
      )
    },
    isEdited () {
      return !this.$_.isEqual(this.scenarioEdit, this.scenarioBeforeEdit)
    },
  },
  updated() {
    let cordable = document.getElementsByClassName("carouselOrderable")
    if(cordable.length > 0) {
      if(window.sortable) {
        window.sortable.destroy("carouselOrderable")
      }
      let uls = cordable[0].getElementsByTagName("ul")
      window.sortable = Sortable.create(uls[0], {group: "carouselOrderable", animation: 100})
    }
  },
  created () {
    this.isColumnLoading = true
    this.$store.dispatch('auth/getCompanyColumnSetting', null)
      .then((data) => {
        this.companyColumns = data
        this.isColumnLoading = false
      })
  },
  mounted () {
    window.addEventListener('keydown', (e) => {
      if (e.key == 'Escape') {
        this.onKeydownEscape ()
      }
    })
    this.initSetScenario()
  },
  watch: {
    isModalEditScenario () {
      this.isCardModalActive = this.isModalEditScenario
    },
    selectItem: {
      handler(newVal, oldVal) {
        if (newVal === 'セッション切替' && this.scenarioEdit.status === 12) {
          // 分岐数を1つに制限
          while (this.scenarioEdit.select.length > 1) {
            this.scenarioEdit.select.pop()
          }
          while (this.scenarioEdit.parameter.length > 1) {
            this.scenarioEdit.parameter.pop()
          }
          
          // パラメータが空の場合は初期化
          if (this.scenarioEdit.parameter.length === 0) {
            this.scenarioEdit.parameter.push({
              pointList: [{ point: '0', terms: '', reset: false }],
              wordList: [{ terms: '', word: '', parts: 0 }],
              userInfoList: [{ word: '', terms: '', column_pk: -1 }],
              miniroboVarsList: [{ word: '', terms: '', variable: '' }],
              random: false,
              sessionSwitch: true
            })
          } else {
            // 既存のパラメータがある場合もsessionSwitchを設定
            this.scenarioEdit.parameter.forEach(p => {
              p.sessionSwitch = true
            })
          }
          
          // selectが空の場合は初期化
          if (this.scenarioEdit.select.length === 0) {
            this.scenarioEdit.select.push({
              msg_type: '',
              message: '',
              text_option: '',
              next_node: '',
              point: '0'
            })
          }
        }
      },
      immediate: false
    },
    modalScenario () {
      this.initSetScenario()
    },
    isCardModalActive () {
      this.isCardModalActive ? console.log('isCardModalActive: true') : this.$store.dispatch('chatbot/closeModalScenario')
      this.quoteFlg = this.scenarioEdit.quote_flg
      if (!this.isCardModalActive) {
        this.applyParameter = {
          disable_email: false,
          default_birth: new Date()
        }
        this.uploadParameter = {
          is_resume: false,
          to_google_drive: false,
          uuid: null,
          username: null,
        }
        this.inputParameter = {
          colomn_name: '',
          custom_tag: '',
          custom: null,
          input_type: '',
          default_birth: new Date(),
          date_type: '',
          apply_flg: false,
          any_flg: false,
          default_flg: false,
          keep_time_hour: 0,
          keep_time_minute: 0
        }
        this.emailParameter = {
          title: '',
          to: '',
          cc: '',
          bcc: '',
          after: 0
        }
        this.movieParameter = {
          url: '',
          use: 'youtube',
          filename: ''
        }
        this.downloadParameter = {
          filename: [],
          filepaths: [],    // DBには保存しない
          tempfilepath: '' // DBには保存しない
        }
        this.resumeParameter = {
          image_required: true,
          default_birth: new Date()
        }
      } else {
        this.initSetScenario()
      }
    },
    isImageSet () {
      const image = this.images.filter(media => Number(media.pk) === Number(this.scenarioEdit.image_ref))
      if (image.length > 0) {
        this.imagName = image[0].name
      } else {
        this.imagName = ''
      }
      this.isImageSet = false
    }
  },
  methods: {
    getCustomName (pk) {
      const idx = this.$_.findIndex(
        this.companyColumns,
        ((obj) => {return obj.pk === pk})
      )
      if (idx == -1) return null
      else return this.companyColumns[idx].name
    },
    getCustomColumnId (name) {
      const idx = this.$_.findIndex(
        this.companyColumns,
        ((obj) => {return obj.name === name})
      )
      if (idx == -1) return null
      else return this.companyColumns[idx].pk
    },
    outputSearch (param) {
      this.scenarioEdit.parameter.search = param
    },
    initSetScenario () {
      // modalScenarioに影響を与えてしまうため、ディープコピーする
      this.scenarioEdit = JSON.parse(JSON.stringify(this.modalScenario))
      if (this.scenarioEdit.status === 6) {
        this.scenarioEdit.mainmessage = this.scenarioEdit.mainmessage.replace('[input]', '').replace('[/input]', '')
      }
      if (this.scenarioEdit.status === 1) {
        this.scenarioEdit.mainmessage = this.scenarioEdit.mainmessage.replace('[cv]', '').replace('[/cv]', '')
        if (JSON.stringify(this.scenarioEdit.parameter) != '[]'
          && JSON.stringify(this.scenarioEdit.parameter) != '""'
          && JSON.stringify(this.scenarioEdit.parameter) != '') {
          var temp = this.scenarioEdit.parameter
          if (!temp.default_birth) this.$set(temp, 'default_birth', new Date())
          this.applyParameter = temp
        }
      }
      if (this.scenarioEdit.status === 13) {
        this.scenarioEdit.mainmessage = this.scenarioEdit.mainmessage.replace('[checkbox]', '').replace('[/checkbox]', '')
        for (const idx in this.scenarioEdit.parameter) {
          this.scenarioEdit.parameter[idx].item_message = alterReplace(this.scenarioEdit.parameter[idx].item_message, true)
        }
      } else if (this.scenarioEdit.status === 6 && this.scenarioEdit.parameter) {
        // 自由入力 初期設定
        var temp = this.scenarioEdit.parameter
        if (!temp.custom) this.$set(temp, 'custom', null)
        if (!temp.input_type) this.$set(temp, 'input_type', '')
        if (!temp.default_birth) this.$set(temp, 'default_birth', new Date())
        if (!temp.date_type) this.$set(temp, 'date_type', '')
        this.inputParameter = temp
      } else if (this.scenarioEdit.status === 7 && this.scenarioEdit.parameter) {
        // ファイルアップロード 初期設定
        if (JSON.stringify(this.scenarioEdit.parameter) != '[]') {
          var temp = this.scenarioEdit.parameter
          this.uploadParameter = temp
        }
      } else if (this.scenarioEdit.status === 8 && this.scenarioEdit.parameter) {
        //履歴書 初期設定
        var temp = this.scenarioEdit.parameter
        if (typeof temp.image_required != 'boolean') temp = {image_required: true}
        if (!temp.default_birth) this.$set(temp, 'default_birth', new Date())
        this.resumeParameter = temp
      } else if (this.scenarioEdit.status === 10 && this.scenarioEdit.parameter) {
        // メール送付 初期設定
        var temp = this.scenarioEdit.parameter
        this.emailParameter = temp
      } else if (this.scenarioEdit.status === 14 && this.scenarioEdit.parameter) {
        // 動画 初期設定
        var temp = this.scenarioEdit.parameter
        this.movieParameter = temp
      } else if (this.scenarioEdit.status === 12 && this.scenarioEdit.parameter) {
        // 条件分岐
        if (this.scenarioEdit.parameter[0].pointList[0].terms) {
          this.selectItem = this.ifItems[0]
        } else if (this.scenarioEdit.parameter[0].wordList[0].terms) {
          this.selectItem = this.ifItems[1]
          for (const idx in this.scenarioEdit.parameter) {
            this.scenarioEdit.parameter[idx].wordList[0].word = alterReplace(this.scenarioEdit.parameter[idx].wordList[0].word, true)
          }
        } else if (this.scenarioEdit.parameter[0].userInfoList && this.scenarioEdit.parameter[0].userInfoList[0].terms) {
          this.selectItem = this.ifItems[2]
          for (const idx in this.scenarioEdit.parameter) {
            this.scenarioEdit.parameter[idx].userInfoList[0].word = alterReplace(this.scenarioEdit.parameter[idx].userInfoList[0].word, true)
          }
        } else if (this.scenarioEdit.parameter[0].miniroboVarsList && this.scenarioEdit.parameter[0].miniroboVarsList[0].terms) {
          this.selectItem = this.ifItems[3]
          for (const idx in this.scenarioEdit.parameter) {
            this.scenarioEdit.parameter[idx].miniroboVarsList[0].word = alterReplace(this.scenarioEdit.parameter[idx].miniroboVarsList[0].word, true)
          }
        } else if (this.scenarioEdit.parameter[0].random == true) {
          this.selectItem = this.ifItems[4]
        } else if (this.scenarioEdit.parameter[0].sessionSwitch == true) {
          this.selectItem = this.ifItems[5]
        } else {
          this.selectItem = ''
        }
      } else if (this.scenarioEdit.status === 15 && this.scenarioEdit.parameter) {
        // プルダウン選択 初期設定
        this.scenarioEdit.mainmessage = this.scenarioEdit.mainmessage.replace('[pulldown]', '').replace('[/pulldown]', '')
        for (let pullDown of this.scenarioEdit.parameter) {
          if (pullDown.pullDownId === '') {
            pullDown.pullDownId = 'None'
          }
          pullDown.title = alterReplace(pullDown.title, true)
          for (let item of pullDown.items) {
            item.itemName = alterReplace(item.itemName, true)
          }
        }
      } else if (this.scenarioEdit.status === 17 && this.scenarioEdit.parameter) {
        this.selectCarousel = this.scenarioEdit.parameter
        for (let [, select] of Object.entries(this.selectCarousel)) {
          select.title = alterReplace(select.title, true)
          select.contents = alterReplace(select.contents, true)
          select.button = alterReplace(select.button, true)
        }
      } else if (this.scenarioEdit.status === 18 && this.scenarioEdit.parameter) {
        // ファイルダウンロード 初期設定
        this.scenarioEdit.mainmessage = this.scenarioEdit.mainmessage.replace('[filedownload]', '').replace('[/filedownload]', '')
        this.downloadParameter = this.scenarioEdit.parameter
      } else if (this.scenarioEdit.status === 20) {
        // 検索パーツ初期設定
        for (let i in this.scenarioEdit.parameter.search) {
          if (!this.scenarioEdit.parameter.search[i].image_ref) {
            this.$set(
              this.scenarioEdit.parameter.search[i],
              'image_ref',
              {
                name: '',
                image_data: '',
                image_id: ''
              })
          }
        }
      } else if (this.scenarioEdit.status === 22) {
        this.scenarioEdit.mainmessage = this.scenarioEdit.mainmessage.replace('[memo]', '').replace('[/memo]', '')
      }
      this.scenarioEdit.mainmessage = alterReplace(this.scenarioEdit.mainmessage, true)
      this.splitMessage()
      this.checkAuthority()
      this.resetStoryParts()
      this.scenarioBeforeEdit = this.$_.cloneDeep(this.scenarioEdit)
      this.isImageSet = true
      this.quoteFlg = this.scenarioEdit.quote_flg
      this.getCitableScenarios()
      this.getSelectList()
    },
    onFileTypeMismatch (file) {
      alert('jpg, gif, png, svg　形式でアップして下さい。')
    },
    onFileSizeExceed (file) {
      alert('ファイルは2MB以下でアップロードして下さい。')
    },
    openSelectModal (type) {
      this.$store.dispatch('mediapool/openSelectModal', {type: type})
    },
    saveImage (id) {
      if (this.isModalChatBotDetail) {
        return
      }
      if (this.carouselEdit) {
        this.carouselNumber.image_ref.image_data = this.selectModalTarget.data.image_data
        this.carouselNumber.image_ref.image_id = id
        this.carouselNumber.image_ref.name = this.selectModalTarget.data.name
      } else if (this.searchEdit) {
        this.searchNumber.image_ref.image_data = this.selectModalTarget.data.image_data
        this.searchNumber.image_ref.image_id = id
        this.searchNumber.image_ref.name = this.selectModalTarget.data.name
      } else {
        if (this.selectModalTarget.type == 'image') {
          if (this.scenarioEdit.status === 5) {
            const image = this.images.filter(media => media.image_id === id)
            if (image.length > 0) {
              this.scenarioEdit.image_ref = image[0].pk
            } else {
              this.scenarioEdit.image_ref = null
            }
          }
          if (this.isRoboPartsSetView) {
            var scenarioData = {
              image_id: id,
              scenario: this.scenarioEdit,
              template_id: this.selectTemplateId
            }
          }
          else {
            var scenarioData = {
              image_id: id,
              scenario: this.scenarioEdit,
              template_id: ''
            }
          }
          this.$store.dispatch('chatbot/setScenarioImage', scenarioData)
        } else if (this.selectModalTarget.type == 'video') {
          var template_id = ''
          if (this.isRoboPartsSetView) {
            template_id = this.selectTemplateId
          }
          this.$store.dispatch('chatbot/uploadMovieFile', {scenario: this.scenarioEdit, data: id, template_id: template_id})
          for (var idx=0; idx < this.videos.length; idx++) {
            if (this.videos[idx].video_id == id) {
              this.movieParameter.filename = this.videos[idx].name
              break
            }
          }
        }
      }
      this.isImageSet = true
    },
    isDisable(){
      var disable = (this.scenarioEdit.status === 0 && !this.scenarioEdit.is_edit && !this.user.isAgent ||
                    this.scenarioEdit.status === 2 && !this.scenarioEdit.is_edit && !this.user.isAgent)
      return disable
    },
    clickSaveScenario (isSaveOnly) {
      this.sendControlLogRelatedChatBot('シナリオパーツ編集', 'シナリオ編集モーダルにて、「会話シナリオ変更」「パーツ確定」または「パーツ確定解除」をクリックした。', this.selectChatbot)
      let scenarioSave = this.$_.cloneDeep(this.scenarioEdit)
      this.isError = true
      var select = scenarioSave.select.map ((e) => {
        if (e.url === '') {
          delete e['url']
        }
        if (e.url !== undefined) {
          if (e.url.slice(-1) == "/") {
            e.url = e.url + "^"
          }
          e.message = `[url]${e.url},${alterReplace(e.content, false)}[/url]`
        } else {
          e.message = alterReplace(e.content, false)
        }
      })      // messageのみの場合は不要なselect, msgtype, templateを削除する
      if (scenarioSave.status === 4) {
        // 日程自動調整保存前チェック
        this.$refs.scheduleEdit.checkSchedule()
        if(this.scheduleCheck === false) {
          // 入力項目にエラーあり
          return false
        } else {
          scenarioSave.parameter = this.calendarParameter
        }
      } else if (scenarioSave.status === 6) {
        if (this.inputParameter.input_type != null) {
          if ((this.inputParameter.input_type == 'free' || this.inputParameter.input_type == 'mail' || this.inputParameter.input_type == '') && this.inputParameter.colomn_name != null) {
            if (this.inputParameter.colomn_name == '面接予定日') {
              alert('面接予定日を設定する際は日付入力形式を選択してください。')
              return false
            }
          }
        } else {
          if (this.inputParameter.colomn_name == '面接予定日') {
            alert('面接予定日を設定する際は日付入力形式を選択してください。')
            return false
          }
        }
        if (this.inputParameter.colomn_name == 'カスタム' && !this.companyColumnSetting.map((column)=>column.pk).includes(this.inputParameter.custom)) {
          alert('設定項目を選択してください。')
          return false
        }
        if (scenarioSave.mainmessage.indexOf('[input][/input]') > -1) scenarioSave.mainmessage += '[input][/input]'
        scenarioSave['parameter'] = this.inputParameter
      } else if (scenarioSave.status === 7) {
        if (this.uploadParameter.to_google_drive) {
          this.uploadParameter.username = this.user.username
          this.uploadParameter.uuid = this.user.userHash
        }
        scenarioSave['parameter'] = this.uploadParameter
      } else if (scenarioSave.status === 1) {
        var mainmessage = scenarioSave.mainmessage
        scenarioSave.mainmessage = '[cv]' + mainmessage + '[/cv]'
        scenarioSave['parameter'] = this.applyParameter
      } else if (scenarioSave.status === 5) {
        scenarioSave.mainmessage = '[image][/image]'
      } else if (scenarioSave.status === 8) {
        scenarioSave.parameter = this.resumeParameter
        // PDF出力チェック
        if (scenarioSave.parameter.is_make_pdf === false) {
          // PDF出力設定関連初期化
          scenarioSave.parameter.enable_download = false
          scenarioSave.parameter.applicant_manage = false
          scenarioSave.parameter.send_mail = false
          scenarioSave.parameter.mail_to = null
          scenarioSave.parameter.save_google_drive = false
          scenarioSave.parameter.drive_info = null
          scenarioSave.parameter.file_name = null
        } else {
          if (scenarioSave.parameter.send_mail === true) {
            // メールアドレス形式チェック
            const strReturn = isMailAddress(this.scenarioEdit.parameter.mail_to, 'TOアドレス')
            if (strReturn !== '') {
              alert(strReturn)
              return false
            }
          }
          if (scenarioSave.parameter.save_google_drive === true) {
            // Googleドライブ設定チェック
            if (scenarioSave.parameter.drive_info) {
              if (!scenarioSave.parameter.drive_info.id) {
                alert('Googleドライブに保存するフォルダを選択してください。')
                return false
              }
            }
            if (!scenarioSave.parameter.file_name) {
              alert('Googleドライブに保存する時のファイル名を入力してください。')
              return false
            }
          }
        }
      } else if (scenarioSave.status === 10) {
        scenarioSave.parameter = this.emailParameter
      } else if (scenarioSave.status === 12) {
        if (this.selectItem === '') {
          alert('分岐内容を選択してください')
          return false
        }
        if (this.selectItem === 'ポイント') {
          for (var parameter of scenarioSave.parameter) {
            if (parameter.pointList[0].terms === '') {
              alert('未入力、または未選択箇所があります。')
              return false
            }
            parameter.wordList[0].terms = ''
            parameter.wordList[0].word = ''
            parameter.wordList[0].parts = 0
            parameter.userInfoList[0].word = ''
            parameter.userInfoList[0].terms = ''
            parameter.userInfoList[0].column_pk = -1
            parameter.miniroboVarsList[0].word = ''
            parameter.miniroboVarsList[0].terms = ''
            parameter.miniroboVarsList[0].variable = ''
            parameter.random = false
            parameter.sessionSwitch = false
          }
        } else if (this.selectItem === 'ワード') {
          for (var parameter of scenarioSave.parameter) {
            if (parameter.wordList[0].word === '' || parameter.wordList[0].terms === '') {
              alert('未入力、または未選択箇所があります。')
              return false
            }
            parameter.pointList[0].point = '0'
            parameter.pointList[0].terms = ''
            parameter.pointList[0].reset = false
            parameter.userInfoList[0].word = ''
            parameter.userInfoList[0].terms = ''
            parameter.userInfoList[0].column_pk = -1
            parameter.miniroboVarsList[0].word = ''
            parameter.miniroboVarsList[0].terms = ''
            parameter.miniroboVarsList[0].variable = ''
            parameter.random = false
            parameter.sessionSwitch = false
          }
          for (const idx in scenarioSave.parameter) {
            scenarioSave.parameter[idx].wordList[0].word = alterReplace(scenarioSave.parameter[idx].wordList[0].word, false)
          }
        } else if (this.selectItem === '応募者情報') {
          if (scenarioSave.parameter[0].userInfoList[0].column_pk == -1) {
            alert('項目を選択してください。')
            return false
          }
          for (var parameter of scenarioSave.parameter) {
            if (parameter.userInfoList[0].word === '' || parameter.userInfoList[0].terms === '') {
              alert('未入力、または未選択箇所があります。')
              return false
            }
            parameter.pointList[0].point = '0'
            parameter.pointList[0].terms = ''
            parameter.pointList[0].reset = false
            parameter.wordList[0].terms = ''
            parameter.wordList[0].word = ''
            parameter.wordList[0].parts = 0
            parameter.miniroboVarsList[0].word = ''
            parameter.miniroboVarsList[0].terms = ''
            parameter.miniroboVarsList[0].variable = ''
            parameter.random = false
            parameter.sessionSwitch = false
          }
          for (const idx in scenarioSave.parameter) {
            scenarioSave.parameter[idx].userInfoList[0].word = alterReplace(scenarioSave.parameter[idx].userInfoList[0].word, false)
          }
        } else if (this.selectItem === 'ミニロボ変数') {
          for (var parameter of scenarioSave.parameter) {
            if (parameter.miniroboVarsList[0].word === '' || parameter.miniroboVarsList[0].terms === '') {
              alert('未入力、または未選択箇所があります。')
              return false
            }
            parameter.pointList[0].point = '0'
            parameter.pointList[0].terms = ''
            parameter.pointList[0].reset = false
            parameter.wordList[0].terms = ''
            parameter.wordList[0].word = ''
            parameter.wordList[0].parts = 0
            parameter.userInfoList[0].word = ''
            parameter.userInfoList[0].terms = ''
            parameter.userInfoList[0].column_pk = -1
            parameter.random = false
            parameter.sessionSwitch = false
          }
          for (const idx in scenarioSave.parameter) {
            scenarioSave.parameter[idx].miniroboVarsList[0].word = alterReplace(scenarioSave.parameter[idx].miniroboVarsList[0].word, false)
          }
        } else if (this.selectItem === 'ランダム') {
          for (var parameter of scenarioSave.parameter) {
            parameter.pointList[0].point = '0'
            parameter.pointList[0].terms = ''
            parameter.pointList[0].reset = false
            parameter.wordList[0].terms = ''
            parameter.wordList[0].word = ''
            parameter.wordList[0].parts = 0
            parameter.userInfoList[0].word = ''
            parameter.userInfoList[0].terms = ''
            parameter.userInfoList[0].column_pk = -1
            parameter.miniroboVarsList[0].word = ''
            parameter.miniroboVarsList[0].terms = ''
            parameter.miniroboVarsList[0].variable = ''
            parameter.random = true
            parameter.sessionSwitch = false
          }
        } else if (this.selectItem === 'セッション切替') {
          // 分岐数を1つに制限
          while (scenarioSave.select.length > 1) {
            scenarioSave.select.pop()
          }
          while (scenarioSave.parameter.length > 1) {
            scenarioSave.parameter.pop()
          }
          
          for (var parameter of scenarioSave.parameter) {
            parameter.pointList[0].point = '0'
            parameter.pointList[0].terms = ''
            parameter.pointList[0].reset = false
            parameter.wordList[0].terms = ''
            parameter.wordList[0].word = ''
            parameter.wordList[0].parts = 0
            parameter.userInfoList[0].word = ''
            parameter.userInfoList[0].terms = ''
            parameter.userInfoList[0].column_pk = -1
            parameter.miniroboVarsList[0].word = ''
            parameter.miniroboVarsList[0].terms = ''
            parameter.miniroboVarsList[0].variable = ''
            parameter.random = false
            parameter.sessionSwitch = false
            parameter.sessionSwitch = true
          }
        }
      } else if (scenarioSave.status === 13) {
        for (var i in scenarioSave.select) {
          scenarioSave.select[i].msg_type = 'checkbox'
        }
        for (let item of scenarioSave.parameter) {
          if (!item.item_message) {
            alert('入力されていないチェック項目があります。')
            return false
          }
        }
        for (const idx in scenarioSave.parameter) {
          scenarioSave.parameter[idx].item_message = alterReplace(scenarioSave.parameter[idx].item_message, false)
        }
      } else if (scenarioSave.status === 14) {
        scenarioSave['parameter'] = this.movieParameter
      } else if (scenarioSave.status === 15) {
        scenarioSave.mainmessage = '[pulldown]' + scenarioSave.mainmessage + '[/pulldown]'
        for (let pullDown of scenarioSave.parameter) {
          if (pullDown.pullDownId === 'None') {
            pullDown.pullDownId = ''
          }
          pullDown.title = alterReplace(pullDown.title, false)
          for (let item of pullDown.items) {
            item.itemName = alterReplace(item.itemName, false)
          }
        }
      } else if (scenarioSave.status === 16) {
        // fromの確認
        if (scenarioSave.parameter.from) {
          // 長さチェック
          if (scenarioSave.parameter.from.length > 11) {
            alert('送信元は11文字以内でお願い致します。')
            return false
          }
          // 英数字チェック
          const reg = new RegExp(/^[0-9a-zA-Z’/ +’ ]*$/)
          if (!reg.test(scenarioSave.parameter.from)) {
            alert('送信元は英数字のみでお願い致します。')
            return false
          }
        }
      } else if (scenarioSave.status === 17) {
        scenarioSave.mainmessage = '[carousel][/carousel]'

        let cos = document.getElementsByClassName("carouselOrder")
        let newOrder = []
        for(let i = 0; i < cos.length; i++) {
          let index = parseInt(cos[i].className.split("-")[1] - 1, 10)
          newOrder.push(this.selectCarousel["select" + (index + 1)])
        }
        for(let i = 0; i < cos.length; i++) {
          newOrder[i].id = i + 1
          this.selectCarousel["select" + (i + 1)] = newOrder[i]
        }

        for (let [, select] of Object.entries(this.selectCarousel)) {
          select.title = alterReplace(select.title, false)
          select.contents = alterReplace(select.contents, false)
          select.button = alterReplace(select.button, false)
        }
        scenarioSave['parameter'] = this.selectCarousel
      } else if (scenarioSave.status === 18) {
        scenarioSave.mainmessage = '[filedownload]' + scenarioSave.mainmessage + '[/filedownload]'
        let file_count = (this.downloadParameter['filepaths'] ? this.downloadParameter['filepaths'].length : 0)
        if (file_count > 0) {
          if (typeof FileReader === 'function') {
            this.downloadParameter['filename'] = []
            let paths = this.downloadParameter['filepaths']
            let loaded_file_count = 0
            let loaded_files = []
            for (let file of paths) {
              let ext = (file[1].name.lastIndexOf('.') < 0 ? '' : file[1].name.slice(file[1].name.lastIndexOf('.')))
              let file_name = file[0] + ext
              this.downloadParameter['filename'].push(file_name)
              const reader = new FileReader()
              reader.onload = event => {
                loaded_files.push([file_name, event.target.result.replace(/^.*,/, '')])
                loaded_file_count++
                if (loaded_file_count === file_count) {
                  this.$store.dispatch('chatbot/uploadAttachmentFile', {scenario_pk: scenarioSave.pk, data: loaded_files})
                }
              }
              reader.onerror = event => {
              }
              reader.readAsDataURL(file[1])
            }
          } else {
            console.warn('file reader is not function')
            alert('大変申し訳ございません。エラーが発生いたしました。')
            return false
          }
        }
        this.downloadParameter['tempfilepath'] = ''
        this.downloadParameter['filepaths'] = []
        scenarioSave['parameter'] = this.downloadParameter
      } else if (scenarioSave.status === 19) {
        // 回答出力
        if (scenarioSave.parameter.output === 'GoogleDrive' &&
            scenarioSave.parameter.file_name.length <= 0) {
          alert('出力ファイル名を入力してください。')
          return false
        }
        scenarioSave.parameter.user_uuid = this.user.userHash
      } else if (scenarioSave.status === 21) {
        if (!scenarioSave.parameter.item_list) {
          alert('PDFへの出力項目を入力してください。')
          return false
        }
        if (!scenarioSave.parameter.file_name) {
          alert('PDFファイル名を入力してください。')
          return false
        }
        if ( scenarioSave.parameter.send_to &&
            !scenarioSave.parameter.attachment_file_name) {
          alert('メール添付時のPDFファイル名を入力してください。')
          return false
        }
        if (scenarioSave.parameter.item_list) {
          // 半角英数字と'_'、'.'のみ
          for (const item of scenarioSave.parameter.item_list.split('\n')) {
            if (!item.match(/^__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/) && !item.match(/^(?!pulldown)\d+/)) {
              alert('PDFへの出力項目に使えるのは引用リストのみです。')
              return false
            }
            if (item.match(/^__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/)[0].length !== item.length &&
                item.match(/^(?!pulldown)\d+/)[0].length !== item.length) {
              alert('PDFへの出力項目に不正な引用リストが含まれています。')
              return false
            }
          }
        }
        if (scenarioSave.parameter.send_to) {
          // メールアドレスフォーマット確認
          const strReturn = isMailAddress(this.scenarioEdit.parameter.send_to, 'PDFファイル送付先')
          if (strReturn !== '') {
            alert(strReturn)
            return false
          }
        }
        if (scenarioSave.parameter.attachment_file_name) {
          // 半角英数字のみ
          const attachment = scenarioSave.parameter.attachment_file_name
          if (attachment.match(/^[0-9A-Za-z]*/)[0].length !== attachment.length) {
            alert("添付ファイル名に使用できるのは半角英数字のみです。")
            return false
          }
        }
      } else if (scenarioSave.status === 22) {
        var mainmessage = scenarioSave.mainmessage
        scenarioSave.mainmessage = '[memo]' + mainmessage + '[/memo]'
      } else if (scenarioSave.status === 0) {
        for (const select of scenarioSave.select) {
          if (!select.message) {
            alert('入力されていない選択肢があります。')
            return false
          }
        }
      } else {
        for (var i in scenarioSave.select) {
          scenarioSave.select[i].msg_type = 'button'
          if (scenarioSave.select[i].text_option === '') {
            scenarioSave.select[i].text_option = 'white'
          }
          if (scenarioSave.select[i].point == '') {
            scenarioSave.select[i].point = '0'
          }
        }
      }
      scenarioSave.quote_flg = this.quoteFlg
      if (!scenarioSave.mainmessage) {
        alert('メッセージ内容を入力してください。')
        return false
      } else {
        scenarioSave.mainmessage = alterReplace(scenarioSave.mainmessage, false)
      }

      if (!isSaveOnly) {
        if (!scenarioSave.is_confirm) {
          if (!confirm('パーツ確定をします。よろしいですか？')) {
                return
          }
          this.modalScenario.is_confirm = !this.modalScenario.is_confirm
          scenarioSave.is_confirm = !scenarioSave.is_confirm
        }
      }

      this.$store.dispatch('chatbot/setScenario', {
        companyid: this.user.companyID,
        scenarioName: scenarioSave.name,
        scenario: scenarioSave
      }).then(() => {
        this.setEditStatus(this.selectChatbot.bot_id, this.user.userHash, scenarioSave.pk)
        if (scenarioSave.is_confirm) {
          alert("パーツ確定しました。")
        }
        this.initSetScenario()
      })
      this.isSaved = true
      this.isError = false

      return true
    },
    addSelect (v) {
      var s = {
        'message': '',
        'msg_type': 'button',
        'text_option': 'white',
        'point': '0',
        'next_node': ''
      }
      this.scenarioEdit.select.push(s)
      if (v) this.scenarioEdit.select[Number(this.scenarioEdit.select.length - 1)].content = v
    },
    addSelectCheckBox () {
      var item_message = {item_message: ''}
      this.scenarioEdit.parameter.push(item_message)
    },
    delSelect (idx) {
      this.scenarioEdit.select.splice(idx, 1)
    },
    delSelectCheckBox (idx) {
      this.scenarioEdit.parameter.splice(idx, 1)
    },
    clickUrl (s) {
      if (s.url === undefined) {
        s.url = ''
      }
      else {
        delete s['url']
      }
    },
    splitMessage () {
      for (let i = 0; i < this.scenarioEdit.select.length; i++) {
        if (this.scenarioEdit.select[i].message.substr(0, 5) === '[url]' && this.scenarioEdit.select[i].message.substr(-6, 6) === '[/url]') {
          var messages = this.scenarioEdit.select[i].message.slice(5).slice(0 ,-6).split('/,')
          var messageArr = messages[0].split(',')
          if (messageArr[0].slice(-1) == "^") {
            messageArr[0] = messageArr[0].slice(0,-1)
          }
          this.scenarioEdit.select[i].url = messageArr[0]
          this.scenarioEdit.select[i].content = alterReplace(messageArr[1], true)
          var flg = false
        } else {
          this.scenarioEdit.select[i].content = alterReplace(this.scenarioEdit.select[i].message, true)
        }
      }
    },
    resetStoryParts () {
      let arr = []
      this.prevStories = []
      for (var s of this.scenarioTable) {
        for (var select of s.select) {
          if (this.modalScenario.beforenode == select.next_node) {
            arr.push(s)
          }
        }      
      }
      let set = new Set(arr);
      this.prevStories = Array.from(set);
    },
    imageMessage (photo, isImageSave) {
      this.photo = photo
      this.isImageSave = isImageSave
    },
    addPattern () {
      var parameter = {
        'pointList': [{
          'point': '0',
          'terms': '',
          'reset': false
        }],
        'wordList': [{
          'word': '',
          'terms': '',
          'parts': 0
        }],
        'userInfoList': [{
          'word': '',
          'terms': '',
          'column_pk': -1
        }],
        'miniroboVarsList': [{
          'word': '',
          'terms': '',
          'variable': ''
        }],
        'random' : false
      }
      this.scenarioEdit.parameter.push(parameter)
    },
    delPattern (index) {
      this.scenarioEdit.parameter.splice(index, 1)
    },
    getBtnFlg (flg) {
      this.quoteFlg = flg
    },
    toggleQuoteList () {
      this.quoteListFlg = !this.quoteListFlg
    },
    getCitableScenarios () {
      this.citableScenarios = []
      let matchSomeScenario = {}
      let matchScenarioTable = []
      let someScenario = []
      let count = 0

      // 起点になるシナリオ
      matchSomeScenario[this.modalScenario.beforenode] = this.modalScenario

      // 全シナリオを取得
      for (let s of this.scenarioTable) {
        matchScenarioTable.push(s) 
      }

      // 引用リスト作成処理
      let makeCitableScenariolList = () => {
        count += 1
        someScenario = {}
        // 全シナリオ分判定する
        for (let s of matchScenarioTable) {
          // シナリオが持つnext_node分判定する
          for (let select of s.select) {
            // スタックしたシナリオのbeforenodeと一致するものを探す
            for (let [, match] of Object.entries(matchSomeScenario)) {
              if (select.next_node === match.beforenode) {
                // next_nodeがスタックしたシナリオのbeforenodeに一致
                if (s.beforenode !== this.modalScenario.beforenode) {
                  // 起点のシナリオは引用リストにはスタックしない
                  if (s.quote_flg === true) {
                    this.citableScenarios.unshift(s)
                  }
                }
                // 同じものを追加しないように上書きしていく
                someScenario[s.beforenode] = s
              }
            }
          }
        }
        // 次に回ってきたときの引用リスト検証シナリオリスト
        matchSomeScenario = someScenario

        // 全シナリオを舐めたら終了
        if (count > matchScenarioTable.length) {
          return
        }
        // 再帰処理
        makeCitableScenariolList()
      }
      // 引用リスト作成
      makeCitableScenariolList()

      // 重複を削除
      this.citableScenarios = this.citableScenarios.filter(function (x, i, self) {
        return self.indexOf(x) === i
      })
    },
    getSelectList () {
      this.selectStoryList = []
      this.selectStoryList.push(this.scenarioEdit.beforenode)
    },
    displayQuoteMsg (msg) {
      if (msg) {
        let alter = ''
        if (msg.indexOf('[checkbox]') > -1) {
          alter = msg.replace('[checkbox]', '').replace('[/checkbox]', '')
          if (alter.length <= 0) {
            alter = 'チェック項目'
          }
        } else if (msg.indexOf('[calendar]') > -1) {
          alter = msg.replace('[calendar]', '').replace('[/calendar]', '')
          if (alter.length <= 0) {
            alter = '日程自動調整'
          }
        } else if (msg.indexOf('[cv]') > -1) {
          alter = msg.replace('[cv]', '').replace('[/cv]', '')
          if (alter.length <= 0) {
            alter = '応募フォーム'
          }
        } else if (msg.indexOf('[input]') > -1) {
          alter = msg.replace('[input]', '').replace('[/input]', '')
          if (alter.length <= 0) {
            alter = '自由入力'
          }
        } else if (msg.indexOf('[pulldown]') > -1) {
          alter = msg.replace('[pulldown]', '').replace('[/pulldown]', '')
          if (alter.length <= 0) {
            alter = 'プルダウン選択'
          }
        } else if (msg.indexOf('[resume]') > -1) {
          alter = msg.replace('[resume]', '').replace('[/resume]', '')
          if (alter.length <= 0) {
            alter = '履歴書フォーム'
          }
        } else if (msg.indexOf('[carousel]') > -1) {
          alter = msg.replace('[carousel]', '').replace('[/carousel]', '')
          if (alter.length <= 0) {
            alter = 'カルーセル選択肢'
          }
        } else {
          alter = msg
        }
        const m = alterReplace(alter, true)
        const len = 10
        if (m.length > len) {
          return m.substring(0, len) + '...'
        } else {
          return m
        }
      } else {
        return ''
      }
    },
    closeEditPage () {
      if (this.isConfirmByParts && this.isEdited) {
        if (!confirm('保存していない内容は破棄されます。')) return
      } 
      this.quoteListFlg = false
      if (this.scenarioEdit.is_confirm) {
        this.$store.dispatch('chatbot/closeModalScenario')
        this.isCardModalActive = false
        this.isSaved = false
      } else {
        if (this.isError) {
          // 編集データにエラーあり
          this.isError = false
        } else {
          // 編集データにエラーなし
          if (!this.isSaved && this.scenarioEdit.status !== 5 && this.scenarioEdit.status !== 9) {
            // 画像表示、Startに戻る以外の時にキャンセルしたら確認する
            if (!confirm('会話シナリオ編集がキャンセルされますが、よろしいですか？')) {
              return
            }
          }
          this.$store.dispatch('chatbot/closeModalScenario')
          this.isCardModalActive = false
          this.isSaved = false
        }
      }
    },
    addCarousel () {
      var number = Object.keys(this.selectCarousel).length + 1
      var addName = "select" + String(number)
      var emptyCarousel = {
        id: number,
        title: '',
        contents: '',
        image_ref: {
          image_data: '',
          image_id: '',
          name: ''
        },
        button: ''
      }
      this.$set(this.selectCarousel, addName, emptyCarousel);
      var s = {
        msg_type: '',
        message: '',
        text_option: '',
        next_node: '',
        point: '0',
      }
      this.scenarioEdit.select.push(s)
      setTimeout(() => {
        this.carouselTab = Object.keys(this.selectCarousel).length - 1
      }, 50)
    },
    editCarousel (i) {
      this.carouselEdit = true
      this.carouselNumber = i
    },
    editSearch (s) {
      this.searchEdit = true
      this.searchNumber = s
    },
    deleteSearchImg (s) {
      s.image_ref.image_data = ""
      s.image_ref.name = ""
    },
    deleteCarouselImage (i) {
      i.image_ref.image_data = ""
      i.image_ref.name = ""
    },
    displayDeleteBtn (i) {
      if (i.image_ref.image_data) {
        return true
      } else {
        return false
      }
    },
    deleteCarouselTag (index, i, s) {
      this.scenarioEdit.select.splice(s, 1)
      var number = Object.keys(this.selectCarousel).length
      this.$delete(this.selectCarousel, index)
      if (number != i["id"]) {
        for (var j = i["id"];  j < number; j++) {
          var newIndex = "select" + String(j + 1)
          var contents = this.selectCarousel[newIndex]
          contents["id"] = contents["id"] - 1

          if (contents != undefined) {
            this.$set(this.selectCarousel, index, contents);
            this.$delete(this.selectCarousel, newIndex);
            index = newIndex
          }
          else {
            this.$delete(this.selectCarousel, newIndex)
          }
        }
      }
      if (s == 0) {
        this.carouselTab = 0
      } else {
        this.carouselTab = s - 1
      }
    },
    loadFile(e) {
      this.downloadParameter.tempfilepath = e
      if (this.downloadParameter.filepaths && this.downloadParameter.filepaths.length === 6) {
        this.downloadParameter.tempfilepath = ''
        return
      }

      let name = this.downloadParameter.tempfilepath.name
      let pos = name.lastIndexOf('.')
      if (pos != -1) name = name.substr(0, pos)
      if (!this.downloadParameter.filepaths) this.downloadParameter.filepaths = []
      this.downloadParameter.filepaths.push([name, this.downloadParameter.tempfilepath])

      this.downloadParameter.tempfilepath = ''
    },
    onKeydownEscape () {
      if (this.isModalEditScenario) {
        this.quoteListFlg = false
        this.$store.dispatch('chatbot/closeModalScenario')
      }
    },
    // 検索パーツ 項目追加
    addSearchRecord (idx) {
      if (this.scenarioEdit.parameter.search.length > 3000) {
        alert('追加の上限値に達しました。')
        return
      }
      this.scenarioEdit.parameter.search.splice(idx + 1, 0, {
        keywords   : '',
        type       : 0,
        title      : '',
        description: '',
        url        : '',
        renkeiID   : '',
        image_ref: {
          image_data: '',
          image_id: '',
          name: ''
        },
      })
    },
    // 検索パーツ 項目削除
    delSearchRecord (idx) {
      if (this.scenarioEdit.parameter.search.length === 1) {
        alert('これ以上削除することはできません。')
        return
      }
      this.scenarioEdit.parameter.search.splice(idx, 1)
    },
    changeMainmessage (v) {
      this.scenarioEdit.mainmessage = v
    },
    changeBtnMessage (v, i) {
      this.scenarioEdit.select[i].message = v
      this.scenarioEdit.select[i].content = v
    },
    changeBtnUrl (v, i) {
      this.scenarioEdit.select[i].url = v
    },
    changeBtnPoint (v, i) {
      this.scenarioEdit.select[i].point = v
    },
    changeInputParam (key, v) {
      this.inputParameter[key] = v
    },
    isExistList (u, list) {
      return this.$_.includes(list, u)
    },
    setEditStatus (botID, userHash, scenarioID) {
      // ロボの編集情報を送信
      let editData = {
        'uuid'       : userHash,
        'bot_id'     : botID,
        'scenario_id': scenarioID,
      }
      this.$store.dispatch('virtualOffice/sendVirtualOfficeSV',
        '[SETSCENARIO]' + JSON.stringify(editData)
      )
    },
    setScheduleParameter (scheduleParameter) {
      this.calendarParameter = scheduleParameter
    },
    setScheduleCheck (flag) {
      this.scheduleCheck = flag
    },
    updateTitle(value) {
      this.emailParameter.title = value
    },
    updateFrom(value) {
      this.emailParameter.from = value
    },
    updateTo(value) {
      this.emailParameter.to = value
    },
    updateCc(value) {
      this.emailParameter.cc = value
    },
    updateBcc(value) {
      this.emailParameter.bcc = value
    },
    updateMainmessage(value) {
      this.scenarioEdit.mainmessage = value
    },
    updateAfter(value) {
      this.emailParameter.after = value
    },
    updateSameDay(value) {
      this.emailParameter.is_same_day = value
    },
    updateImageRequired(value) {
      this.resumeParameter.image_required = value
    },
    updateIsResume(value) {
      this.uploadParameter.is_resume = value
    },
    updateToGoogleDrive(value) {
      this.uploadParameter.to_google_drive = value
    },
    updateDriveInfo(info) {
      this.uploadParameter.drive_info = (
        this.uploadParameter.drive_info ?
        Object.assign(this.uploadParameter.drive_info, info) :
        info
      )
    },
    updateSelectItem(value) {
      this.selectItem = value
    },
    updatePointListPoint(...args) {
      const [i, value] = args
      this.scenarioEdit.parameter[i].pointList[0].point = value
    },
    updatePointListTerms(...args) {
      const [i, value] = args
      this.scenarioEdit.parameter[i].pointList[0].terms = value
    },
    updatePointListReset(...args) {
      const [i, value] = args
      this.scenarioEdit.parameter[i].pointList[0].reset = value
    },
    updateWordPartsNumber(num) {
      const len = this.scenarioEdit.parameter.length
      for (let i=0; i<len; i++) this.scenarioEdit.parameter[i].wordList[0].parts = num
    },
    updateWordListWord(...args) {
      const [i, value] = args
      this.scenarioEdit.parameter[i].wordList[0].word = value
    },
    updateWordListTerms(...args) {
      const [i, value] = args
      this.scenarioEdit.parameter[i].wordList[0].terms = value
    },
    updateUserInfoQuotes(column_pk) {
      this.scenarioEdit.parameter.forEach(param => {
        if (!param.userInfoList) param.userInfoList = [{
          word: '',
          terms: '',
          column_pk: -1
        }]
        param.userInfoList[0].column_pk = Number(column_pk)
      });
    },
    updateUserInfoWord(...args) {
      const [i, value] = args
      this.scenarioEdit.parameter[i].userInfoList[0].word = value
    },
    updateUserInfoTerms(...args) {
      const [i, value] = args
      this.scenarioEdit.parameter[i].userInfoList[0].terms = value
    },
    updateMiniroboVariable(value) {
      this.scenarioEdit.parameter.forEach(param => {
        if (!param.miniroboVarsList) param.miniroboVarsList = [{
          word: '',
          terms: '',
          variable: ''
        }]
        param.miniroboVarsList[0].variable = value
      });
    },
    updateMiniroboWord(...args) {
      const [i, value] = args
      this.scenarioEdit.parameter[i].miniroboVarsList[0].word = value
    },
    updateMiniroboTerms(...args) {
      const [i, value] = args
      this.scenarioEdit.parameter[i].miniroboVarsList[0].terms = value
    },
    updateFilepath(...args) {
      const [i, value] = args
      this.downloadParameter.filepaths[i][0] = value
    },
    partsConfirm () {
      this.sendControlLogRelatedChatBot('シナリオパーツ編集', 'シナリオ編集モーダルにて、「会話シナリオ変更」「パーツ確定」または「パーツ確定解除」をクリックした。', this.selectChatbot)
      this.modalScenario.is_confirm = !this.modalScenario.is_confirm
      this.$store.dispatch('chatbot/setScenario', {
        companyid: this.user.companyID,
        scenarioName: this.modalScenario.name,
        scenario: this.modalScenario
      }).then(() => {
        this.setEditStatus(this.selectChatbot.bot_id, this.user.userHash, this.modalScenario.pk)
        this.scenarioEdit.is_confirm = this.modalScenario.is_confirm
        if (!this.scenarioEdit.is_confirm) {
          alert("パーツ確定を解除しました。")
        } else {
          alert("パーツ確定しました。")
        }
        this.initSetScenario()
      })
    },
    changeConfirm() {
      this.partsConfirm ()
    },
    typeParts (idx) {
      if (idx === 100) {
        return 'パーツセット'
      }
      for (var card of this.cardList) {
        if (card.statusIdx == idx + 1) {
          return card.name
        }
      }
    },
    countParts (idx) {
      let count = 0
      for (var s of this.scenarioTable) {
        if (s.status == idx) {
          count += 1
        }
      }
      return count
    },
    countConfirmParts (idx) {
      let count = 0
      for (var s of this.scenarioTable) {
        if (s.status == idx) {
          if (s.is_confirm) {
            count += 1
          }
        }
      }
      return count
    },
    isTypePrevParts() {
      for (var s of this.scenarioTable) {
        if (s.pk == this.scenarioEdit.pk) {
          return false
        } else if (s.status != this.scenarioEdit.status) {
          return true
        }
      }
    },
    isPrevParts () {
      if (this.scenarioTable[0].pk == this.scenarioEdit.pk) {
        return false
      }
      return true
    },
    isNextParts () {
      var scenarioTableReverse = []
      for (var s of this.scenarioTable) {
        scenarioTableReverse.unshift(s)
      }
      // var scenarioTableReverse = this.scenarioTable.reverse()
      if (scenarioTableReverse[0].pk == this.scenarioEdit.pk) {
        return false
      }
      return true
    },
    isTypeNextParts () {
      var scenarioTableReverse = []
      for (var s of this.scenarioTable) {
        scenarioTableReverse.unshift(s)
      }
      // var scenarioTableReverse = this.scenarioTable.reverse()
      for (var s of scenarioTableReverse) {
        if (s.pk == this.scenarioEdit.pk) {
          return false
        } else if (s.status != this.scenarioEdit.status) {
          return true
        }
      }
    },
    isPartsLock (idx) {
      if (this.countParts(idx) == this.countConfirmParts(idx)) {
        return false
      }
      return true
    },
    discardEdit() {
      this.$store.commit('chatbot/RESTORE_PARTS')
      this.initSetScenario()
    },
    typePrevParts() {
      if (!this.isEdited || confirm('保存していない内容は破棄されます。')) {
        this.$store.dispatch('chatbot/changePartsTypePrev')
      }
    },
    prevParts() {
      if (!this.isEdited || confirm('保存していない内容は破棄されます。')) {
        this.$store.dispatch('chatbot/changePartsPrev')
      }
    },
    nextParts() {
      if (!this.isEdited || confirm('保存していない内容は破棄されます。')) {
        this.$store.dispatch('chatbot/changePartsNext')
      }
    },
    typeNextParts() {
      if (!this.isEdited || confirm('保存していない内容は破棄されます。')) {
        this.$store.dispatch('chatbot/changePartsTypeNext')
      }
    },
    lockTypeParts(idx) {
      for (var s of this.scenarioTable) {
        if (s.status == idx) {
          s.is_confirm = true
          this.$store.dispatch('chatbot/setScenario', {
            companyid: this.user.companyID,
            scenarioName: this.selectScenario,
            scenario: s
          }).then(() => {
            this.setEditStatus(this.selectChatbot.bot_id, this.user.userHash, this.modalScenario.pk)
            this.scenarioEdit.is_confirm = this.modalScenario.is_confirm
          })
        }
      }
      alert("パーツ確定しました。")
    },
    checkAuthority () {
      if(this.user.isAgent) {
        this.isCheckAuthority = true
        return
      }
      let chatbot = []
      for (let c of this.chatbots) {
        if (c.scenario_name == this.modalScenario.name) {
          chatbot.push(c)
        }
      }
      for (let robo of chatbot) {
        if (robo.editor == this.user.userHash ||
            robo.create_by == this.user.userHash) {
          this.isCheckAuthority = true
          return
        }
      }
      this.isCheckAuthority = false
      return
    },
    nextMessage (message) {
      if (message == "") {
        return "次のパーツ"
      } else {
        return message
      }
    },
    changeScenarioStatus (node) {
      for (var s of this.scenarioTable) {
        if (s.beforenode == node) {
          if (s.status === 100) {
            return 'パーツセット'
          } else {
            return this.checkCard(s.status)
          }
        }
      }
    },
    checkCard (status) {
      for (var c of this.cardList) {
        if (c.statusIdx == status + 1) {
          return c.name
        }
      } 
    },
    changeScenarioMessage (node) {
      for (var s of this.scenarioTable) {
        if (s.beforenode == node) {
          return s.mainmessage
        }
      }
    },
    prevStoryStatus () {
      for (var s in this.selectStoryList) {
        if (this.scenarioEdit.beforenode == this.selectStoryList[s]) {
          for (var t of this.scenarioTable) {
            if (t.beforenode == this.selectStoryList[s-1]) {
              return this.checkCard(t.status)
            }
          }
        }
      }
    },
    prevStoryMessage () {
      for (var s in this.selectStoryList) {
        if (this.scenarioEdit.beforenode == this.selectStoryList[s]) {
          if (s.status === 100) {
            return s.parameter.robo_parts_set_name
          } else {
            return s.mainmessage
          }
          for (var t of this.scenarioTable) {
            if (t.beforenode == this.selectStoryList[s-1]) {
              return t.mainmessage
            }
          }
        }
      }
    },
    storyPrevParts () {
      this.selectStoryList.pop()
      this.$store.dispatch('chatbot/changeStoryParts', this.selectStoryList[this.selectStoryList.length-1])
    },
    storyChangeParts (node) {
      this.selectStoryList.push(node)
      this.$store.dispatch('chatbot/changeStoryParts', node)
    },
    countStoryConfirm (node) {
      if (this.confirmStories(node) - this.allStories(node) == 0) {
        return true
      } else {
        return false
      }
    },
    isNextMessage (node) {
      if (node == "") {
        return false
      } else if (this.selectStoryList.includes(node)) {
        return false
      }
      return true
    },
    confirmStories (node) {
      var flg = true
      var li = []
      var count = 0
      var selectList = this.selectStoryList.slice();
      selectList.push(node)
      for (var all in this.allStory) {
        flg = true
        li = this.allStory[all]
	      for (var s in selectList) {
		      if (selectList[s] != this.allStory[all][s]) {
            flg = false
          }
        }
        if (flg) {
          if (this.storyConfirm[all] == "true") {
            count += 1
          }
        }
      }
      return count
    },
    countConfirmStories () {
      var count = 0
      for (var s of this.storyConfirm) {
        if (s == "true") {
          count += 1
        }
      }
      return count
    },
    allStories(node) {
      var flg = true
      var li = []
      var allList = []
      var selectList = this.selectStoryList.slice();
      selectList.push(node)
      for (var all of this.allStory) {
        flg = true
        li = all
	      for (var s in selectList) {
		      if (selectList[s] != all[s]) {
            flg = false
          }
        }
        if (flg) {
          allList.push(li)
        }
      }
      return allList.length
    },
    getStoryFlg () {
      var selectList = this.selectStoryList.slice();
      selectList.push("")
      for (var all in this.allStory) {
		    if (this.allStory[all].toString() == selectList.toString()) {
          if (this.storyConfirm[all] == "true") {
            return true
          } else {
            return false
          }
        }
      }
    },
    confirmStory () {
      var selectList = this.selectStoryList.slice();
      selectList.push("")
      for (var all in this.allStory) {
		    if (this.allStory[all].toString() == selectList.toString()) {
          this.storyConfirm[all] = "true"
          break
        }
      }
      var str = this.storyConfirm.join(',');
      this.$store.dispatch('chatbot/updateConfirmStory', {name:this.scenarioEdit.name, story_confirm:str})
      .then(() => {
        this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: this.scenarioEdit.name})
        .then(() => {
          this.getSelectList()
        })
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.card-header {
  display: flex;
}
.card-header-parts {
  display: flex;
  height: 50px;
  padding: 10px;
  border-bottom: solid thin #ccc;
}
.edit-title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.edit-title {
  font-size: 22px;
  font-weight: 700;
}
.quote-container {
  display: flex;
}
.quote-btn-container {
  width: 164px;;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 12px;
  border: solid 1px #dbdbdb;
  margin-right: 8px;
}
.quote-btn {
  width: 64px;
}
.message {
  background: #ffffff;
  max-height: calc(100vh - 300px);
  padding: 8px;
  .comment {
    text-align: left;
    color: grey;
    font-size: 13px;
  }
}
.tab-box {
  background: white;
  border: solid thin #ccc;
  border-radius: 8px;
  height: 350px;
  padding: 16px;
}
.tab-box-form {
  width: 100%; display: flex; padding: 8px;
}
.tab-box-left {
  width: 40%; display: flex; justify-content: flex-start; align-items: center;
}
.tab-box-right {
  width: 60%;
  font-size: 13px;
  padding: 10px;
  justify-content: flex-start;
  display: flex;
  align-items: center;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.checkbox-item-container {
  font-size: 14px;
  padding:10px;
  padding-left:20px;
  &.-wrapper {
    align-items: center;
  }
}
.checkbox-index {
  margin-right: 8px;
}

/* ポイント入力の際勝手に動くバグがあるため、手動入力に変更 */
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance:textfield;
}
input::-ms-clear {
  visibility:hidden
}

.quote-list {
  height: 240px;
  position: absolute;
  right: 8px;
  width: 560px;
  border-radius: 5px;
  text-align: left;
  background-color: #ffffff;
  box-shadow: 0 0 3px grey;
  z-index: 10;
  .list-title {
    font-weight: bold;
    margin-bottom: 8px;
  }
}
.quote-list-wrapper {
  margin: 8px;
}
.open-quote-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.open-quote-btn {
  cursor: pointer;
}
.quote-list-content {
  table {
    margin: auto;
    font-size: 12px;
  }
  table th {
    padding: 4px;
  }
  table td {
    padding: 4px;
  }
}
table thead th {
  top: 0;
  z-index: 1;
  background: #ffffff;
  border: 1px solid #000000;
}
.not-find-quote {
  font-size: 12px;
}
.quote-explain {
  font-size: 12px;
  margin-bottom: 16px;
}
.add-carousel-tag {
  height: 30px;
  background-color: white;
  display: flex;
  justify-content: space-between;
  vertical-align: middle;
}
.select-wrapper {
  max-width: 200px;
}
.footer-box {
  width: 100%;
  height: 80px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;

  button {
    width: 47%;
  }
}
.footer-box-stories {
  width: 100%;
  height: 20px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}
.footer-box .footer-box-parts{
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  .footer-tool-tip {
    margin: 0 auto;
  }
}

.footer-box .footer-box-parts a{
  /*color: #AA0167;*/
  font-size: 50px;
}

.card-content-parts {
  height: 400px;
}
.card-content-stories {
  width: 680px;
  height: 460px;
  float: left;
}
.story-box {
  width: 140px;
  height: 480px;
  float: left;
}
.story-card {
  padding: 8px;
  border: 1px solid;
  border-radius: 8px;
  overflow-wrap: normal;
  text-align: left;
  font-size: 10px;
  height: 100px;
  width: 112px;
  margin: 8px;
  overflow: scroll;
  cursor: pointer;
}
.story-card-grey {
  background-color: #E0E0E0;
}
.column {
  height: 500px;
}

</style>



// WEBPACK FOOTER //
// src/components2/Robo/modal/organisms/ScenarioEditor.vue